import { render, staticRenderFns } from "./TDSForm.vue?vue&type=template&id=725ad740&"
import script from "./TDSForm.vue?vue&type=script&lang=js&"
export * from "./TDSForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports